

import { Link, useNavigate } from "react-router-dom";
import {
  menu
} from "../../data/mainMenuData";
import {
  isActiveParentD,
  isActiveLinkD,
  isActiveParentChaildD,
} from "../../../src/utils/linkActiveChecker";
import "../../../src/components/i18n/lang"

import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
const HeaderNavContent = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  return (
    <>
      <nav className="nav main-menu">
        <ul className="navigation" id="navbar">
          {/* current dropdown */}
          {/* {menu.map((item) => (
            <li
              className={`${isActiveParentD(item.items, pathname) || isActiveLinkD(item.path, pathname) ? "current" : ""
                }${item.items.length > 0 ? 'dropdown' : ""}`}
              key={item.id} >
              <Link to={item.path}>{t(item.code)}</Link>
              {item.items.length > 0 ? (
                <ul>
                  {item.items.map((itemC, row) => (
                    itemC.items.length > 0 ? <li className={`${itemC.items.length > 0 ? "dropdown" : ''}`} >
                      <br key={row.uniqueId}></br>
                      <span
                        className={
                          isActiveParentChaildD(itemC.items, pathname)
                            ? "current"
                            : ""
                        }
                      >
                        {t(itemC.code)}
                      </span>
                      <ul>
                        {itemC.items.map((menu, row) => (
                          <li
                            className={
                              isActiveLinkD(menu.path, pathname)
                                ? "current"
                                : ""
                            }
                            key={row.uniqueId} >
                            <Link to={menu.path}>{t(menu.code)}</Link>
                          </li>
                        ))}
                      </ul>
                    </li> : ''
                  ))}
                </ul>
              ) : ''}

            </li>

          ))} */}
        </ul>
      </nav>
    </>
  );
};

export default HeaderNavContent;
